import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class AlertDialogSlide extends React.Component {
  state = {
    open: false,
  };

  componentWillReceiveProps(props) {
    this.setState({
      open: props.open,
    });
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleNo = () => {
    this.setState({ open: false });
    this.props.handleAgrement(false, 'no');
  };

  handleYes = () => {
    this.setState({ open: false });
    this.props.handleAgrement(false, 'yes');
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            {this.props.formTitle}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
                Please, be careful while you clearing the
                forms then there is no chance to take them back!
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleNo} color="primary">
              No
            </Button>
            <Button onClick={this.handleYes} color="primary">
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default AlertDialogSlide;
